
import Vue from 'vue';
import {
	RunnitNodeDefTagType,
	READABLE_RUNNIT_NODE_DEF_TAG_TYPE,
	RUNNIT_NODE_DEF_TAG_TYPE,
	RUNNIT_NODE_DEF_TAG_TYPE_ICON,
} from '@run-diffusion/shared';
import { mapState } from 'vuex';

export default Vue.extend({
	name: 'RunnitTagTypeSelect',
	props: {
		showCompanyCategory: { type: Boolean, default: false },
		selectedTypes: { type: Array, default: () => [] },
		isAllCategorySelected: { type: Boolean, default: false },
		isCompanyCategorySelected: { type: Boolean, default: false },
		multiSelect: { type: Boolean, default: false },
	},
	data () {
		return {
			RUNNIT_NODE_DEF_TAG_TYPE,
		};
	},
	computed: {
		...mapState([
			'team',
		]),
		items () {
			return Object.values(RUNNIT_NODE_DEF_TAG_TYPE).filter((tagType: RunnitNodeDefTagType) => {
				const excludedTypes: RunnitNodeDefTagType[] = [
					RUNNIT_NODE_DEF_TAG_TYPE.HOME_PAGE,
					RUNNIT_NODE_DEF_TAG_TYPE.INDUSTRY,
					RUNNIT_NODE_DEF_TAG_TYPE.TRAINING_TYPE,
					RUNNIT_NODE_DEF_TAG_TYPE.TRAINING_QUALITY,
					RUNNIT_NODE_DEF_TAG_TYPE.INTERNAL,
				];
				return !excludedTypes.includes(tagType);
			}).map((t: RunnitNodeDefTagType, i: number) => {
				return {
					id: i,
					label: READABLE_RUNNIT_NODE_DEF_TAG_TYPE[t],
					tagType: t,
					icon: RUNNIT_NODE_DEF_TAG_TYPE_ICON[t]
				}
			})
		},
		selectedTypesMap () {
			return this.selectedTypes.reduce((map: Record<RunnitNodeDefTagType, boolean>, tagType: RunnitNodeDefTagType) => ({
				...map,
				[tagType]: true,
			}), {});
		},
	},
	methods: {
		onSelectAllCategory () {
			this.$emit('on-all-category-selected');
		},
		onSelectCompanyCategory () {
			this.$emit('on-company-category-selected');
		},
		handleOptionSelection (selectedItem) {
			let selectedTypes: RunnitNodeDefTagType[] = [...this.selectedTypes];

			if (this.isAllCategorySelected) {
				selectedTypes = [];
			}

			if (this.multiSelect) {
				if (selectedTypes.includes(selectedItem.tagType)) {
					selectedTypes = selectedTypes.filter((tagType: RunnitNodeDefTagType) => tagType !== selectedItem.tagType);
				} else {
					selectedTypes.push(selectedItem.tagType);
				}
			} else {
				selectedTypes = [selectedItem.tagType];
			}

			if (!selectedTypes.length) {
				this.onSelectAllCategory();
			} else {
				this.$emit('on-select', selectedTypes);
			}
		},
	},
});
